import type { Translate } from '@autoplan/common'
import type { UiLabels } from '@autoplan/web-ui'

export function buildUiLabels(t: Translate): UiLabels {
  return {
    select: t('common.actions.select'),
    selectOption: t('common.actions.selectOption'),
    noOptions: t('common.status.noOptions'),
    more: t('common.ui.more'),
    search: t('common.actions.searchPlaceholder'),
    export: t('common.actions.export'),
    copied: t('common.status.copied'),
    loading: t('common.status.fetchingData'),
    noData: t('common.status.noData'),
    breadcrumb: t('common.ui.breadcrumb'),
    closeSortMenu: t('common.ui.closeSortMenu'),
    sliderFrom: t('common.labels.from'),
    sliderTo: t('common.labels.to'),
    unlock: t('common.ui.unlock'),
    footerAbout: t('common.footer.about'),
    footerContact: t('common.footer.contact'),
    reportDamage: {
      error: t('common.status.somethingWentWrong'),
      lastKnownPartner: t('common.reportDamage.lastKnownPartner'),
      unknownPartner: t('common.status.unknown'),
      goTo: t('common.reportDamage.goTo'),
      insurer: t('common.reportDamage.insurer'),
      registerDamage: t('common.reportDamage.registerDamage'),
      customerServicePhone: t('common.reportDamage.customerServicePhone'),
    },
    lostFuelCard: {
      noProducts: t('common.lostFuelCard.noProducts'),
      closeWindow: t('common.lostFuelCard.closeWindow'),
      error: t('common.lostFuelCard.error'),
      sending: t('common.lostFuelCard.sending'),
      success: t('common.lostFuelCard.success'),
      intro: t('common.lostFuelCard.intro'),
      registrationNumber: t('common.labels.registrationNumber'),
      registrationNumberRequired: t('common.lostFuelCard.registrationNumberRequired'),
      productType: t('common.lostFuelCard.productType'),
      productTypeRequired: t('common.lostFuelCard.productTypeRequired'),
      selectProduct: t('common.lostFuelCard.selectProduct'),
      address: t('common.labels.address'),
      addressRequired: t('common.lostFuelCard.addressRequired'),
      postalCode: t('common.labels.postalCode'),
      postalCodeRequired: t('common.lostFuelCard.postalCodeRequired'),
      city: t('common.labels.city'),
      cityRequired: t('common.lostFuelCard.cityRequired'),
      comment: t('common.labels.comment'),
      commentPlaceholder: t('common.lostFuelCard.commentPlaceholder'),
      order: t('common.actions.order'),
    },
  }
}
